var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"kpb-embed",style:(`--kpb-embed-aspect-ratio: ${_vm.aspectRatio}; --kpb-embed-background-color: ${_vm.backgroundColor}`),attrs:{"src":_vm.data.src,"frameborder":"0","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }